import { Apple, Play } from "lucide-react";

const badges = [
  { icon: Apple, top: "Download on the", bottom: "App Store", testid: "app-store-badge" },
  { icon: Play, top: "Get it on", bottom: "Google Play", testid: "google-play-badge" },
];

export default function StoreBadges() {
  return (
    <div data-testid="store-badges">
      <div className="flex flex-wrap gap-4">
        {badges.map((b) => (
          <button
            key={b.testid}
            type="button"
            data-testid={b.testid}
            className="flex items-center gap-3 bg-ink/50 backdrop-blur border border-bone/25 rounded-xl px-5 py-3 text-bone transition-colors duration-300 hover:border-honey"
          >
            <b.icon className="w-7 h-7" strokeWidth={1.5} />
            <span className="text-left leading-tight">
              <span className="block text-[10px] uppercase tracking-wider text-bone/60">{b.top}</span>
              <span className="block text-base font-semibold">{b.bottom}</span>
            </span>
          </button>
        ))}
      </div>
      <p className="text-xs text-bone/50 mt-3 max-w-md" data-testid="store-badges-note">
        Currently in Beta Testing — Download now to be among the first beekeepers to try ApiaryKeeper.
      </p>
    </div>
  );
}
